import { Network } from 'turbos-clmm-sdk';
import { type Config } from './mainnet';
import testnet from './testnet';

const development: Config = {
  ...testnet,
  sui_network: Network.devnet,
  api_url: 'https://api.turbos.finance/devnet',
  // api_url: 'https://api.turbos.finance/testnet/',
  rpc: {
    sui_Official: 'https://fullnode.testnet.sui.io:443',
    shinami: 'https://api.shinami.com/node/v1/sui_testnet_60d3c675a6d403e634a0a04c2101a6bc',
  },
};

export default development;
